<template>
  <b-card
    body-class="p-0"
    class="-mt-[12px]"
  >
    <div class="flex items-center justify-between flex-wrap flex-col sm:flex-row gap-[16px] p-[18px]">
      <div class="flex items-center w-full sm:w-auto gap-[8px]">
        <b-button
          variant="primary"
          size="sm"
          class="rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <h3 class="text-xl text-black font-semibold w-full sm:w-auto mb-0">
          Pengajuan Produk
        </h3>
      </div>
    </div>

    <div class="px-[18px] mb-[18px]">
      <p class="text-black mb-[2px] text-[14px]">
        Tanggal Pengajuan:
      </p>
      <p
        class="text-black font-semibold mb-0"
        :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-full max-w-[120px]': isOnLoading }"
      >
        {{ submissionDate }}
      </p>
    </div>

    <WarehouseProfile
      :submission-detail="submissionDetail"
      :is-on-loading="isOnLoading"
    />

    <div class="mt-[24px] mb-[8px]">
      <div class="flex items-center justify-between mb-[16px]">
        <h4 class="text-black text-[16px] font-semibold px-[18px] mb-0">
          Daftar Produk
        </h4>
        <b-button
          v-if="submissionRejected"
          variant="outline-primary"
          size="sm"
          class="mx-[18px]"
          @click="viewRejectionNote"
        >
          Lihat Catatan Penolakan
        </b-button>
      </div>
      <ProductsTable
        ref="productsTable"
        :products="productData"
        :is-on-loading="isOnLoading"
        :warehouse-id="warehouseId"
      />
    </div>

    <ModalViewRejectionNote ref="modalViewRejectionNote" />
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { DAY_MONTH_YEAR } from '@/libs/formatDate'
import WarehouseProfile from './WarehouseProfile.vue'
import ProductsTable from './ProductsTable.vue'
import ModalViewRejectionNote from './ModalViewRejectionNote.vue'

export default {
  name: 'StorageRequestDetail',
  components: {
    WarehouseProfile,
    ProductsTable,
    ModalViewRejectionNote,
  },
  data() {
    return {
      isOnLoading: false,
      submissionDetail: undefined,
      submissionDetailError: false,
      isAllSelected: false,
      thereIsOneSelected: false,
      selectedProducts: [],
      isOnMutateApproval: false,
    }
  },
  computed: {
    ...mapState('auth', ['userData']),
    productData() {
      return this.submissionDetail?.details || []
    },
    submissionDate() {
      if (!this.submissionDetail?.submission_date || this.isOnLoading) {
        return ''
      }
      return DAY_MONTH_YEAR(this.submissionDetail.submission_date)
    },
    submissionRejected() {
      return this.submissionDetail?.submission_status === 'Ditolak'
    },
    warehouseId() {
      return this.submissionDetail?.warehouse_id
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      this.fetchSubmissionDetail(to.params.id)
    }
    next()
  },
  mounted() {
    this.fetchSubmissionDetail()
  },
  methods: {
    fetchSubmissionDetail(id = null) {
      const submissionId = id || this.$route.params.id
      this.isOnLoading = true
      return this.$http_new.get(`/komship/api/v1/submissions/${submissionId}/partner`)
        .then(response => {
          const { data } = response.data
          const mappedData = {
            ...data,
            details: data.details.map(detail => ({
              ...detail,
              _showDetails: detail.bundle_component?.length > 0,
            })),
          }
          this.submissionDetail = mappedData
        }).catch(error => {
          this.submissionDetailError = true
          this.submissionDetail = undefined
        }).finally(() => {
          this.isOnLoading = false
        })
    },
    viewRejectionNote() {
      this.$refs.modalViewRejectionNote.show({
        note: this.submissionDetail?.reason,
      })
    },
  },
}
</script>
